import Swal from "sweetalert2";
import "../../styles/hc-modal.css";

/* ============================================================================
   hcSwal — los diálogos de aviso/confirmación con la piel del rediseño.

   Es el MISMO SweetAlert2 que ya usa el proyecto (ninguna dependencia nueva),
   con `buttonsStyling: false` y `customClass` apuntando a clases propias, que
   se pintan con los tokens `--hc-*` en hc-modal.css. Así el aviso deja de ser
   un cuadro con un signo de interrogación azul gigante y botones morados.

   Está DELIBERADAMENTE limitado a Historia Clínica: el resto de la aplicación
   sigue con `Swal.fire` tal cual. Restilar los avisos de las 40 pantallas es
   otra decisión, no un efecto colateral de esta.
   ========================================================================== */

const CLASES = {
    container: "hcsw__cont",
    popup: "hcsw",
    header: "hcsw__head",
    title: "hcsw__title",
    htmlContainer: "hcsw__body",
    input: "hcsw__input",
    inputLabel: "hcsw__inputLabel",
    validationMessage: "hcsw__valid",
    actions: "hcsw__actions",
    confirmButton: "hcbtn hcbtn--primario",
    cancelButton: "hcbtn",
    denyButton: "hcbtn",
    footer: "hcsw__footer",
    icon: "hcsw__icon",
};

const base = Swal.mixin({
    buttonsStyling: false,
    customClass: CLASES,
    reverseButtons: true, // Cancelar a la izquierda, acción a la derecha (como el pie de HCModal)
    heightAuto: false, // no empuja el layout de la página al abrirse
    showClass: { popup: "hcsw--in" },
    hideClass: { popup: "hcsw--out" },
});

/** Confirmación. `peligroso` pinta el primario en rojo, no el icono. */
export function hcConfirmar({
    titulo,
    texto,
    html,
    confirmar = "Confirmar",
    cancelar = "Cancelar",
    peligroso = false,
    input,
    inputPlaceholder,
}) {
    return base.fire({
        title: titulo,
        text: texto,
        html,
        input,
        inputPlaceholder,
        showCancelButton: true,
        confirmButtonText: confirmar,
        cancelButtonText: cancelar,
        customClass: {
            ...CLASES,
            confirmButton: peligroso ? "hcbtn hcbtn--peligro" : "hcbtn hcbtn--primario",
        },
    });
}

/** Aviso breve que se va solo. No interrumpe: no lleva botones. */
export function hcExito(titulo, texto) {
    return base.fire({
        title: titulo,
        text: texto,
        timer: 2200,
        showConfirmButton: false,
        customClass: { ...CLASES, popup: "hcsw hcsw--ok" },
    });
}

/** Error: SÍ espera un clic. Un fallo no debe desaparecer sin que se lea. */
export function hcError(titulo, texto) {
    return base.fire({
        title: titulo,
        text: texto,
        confirmButtonText: "Entendido",
        customClass: { ...CLASES, popup: "hcsw hcsw--error" },
    });
}

/** Aviso que SÍ espera un clic: hay algo que el médico tiene que leer. */
export function hcAviso(titulo, texto) {
    return base.fire({
        title: titulo,
        text: texto,
        confirmButtonText: "Entendido",
        customClass: { ...CLASES, popup: "hcsw hcsw--aviso" },
    });
}

export function hcInfo(titulo, texto) {
    return base.fire({
        title: titulo,
        text: texto,
        timer: 2600,
        showConfirmButton: false,
        customClass: { ...CLASES, popup: "hcsw hcsw--info" },
    });
}

export default base;
